import { useStore } from '@/utils/useStore'

export default defineStore('pages', () => {
  const { getItem, getItems, setItem, deleteItem } = useStore('page')

  return {
    setItem, deleteItem,
    getItems, getItem
  }
})